import { useRequiredContext } from "@redotech/react-util/context";
import { ExtensionShopifyClientContext } from "@redotech/redo-shopify-extension/shopify";
import { ReactNode, createContext, memo, useCallback } from "react";

export type GetActiveCartIdFn = () => Promise<string | undefined>;

export const GetActiveCartIdContext = createContext<
  GetActiveCartIdFn | undefined
>(undefined);

export const GetActiveCartIdProvider = memo(function GetActiveCartIdProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const extensionShopifyClient = useRequiredContext(
    ExtensionShopifyClientContext,
  );

  const getActiveCartId = useCallback<GetActiveCartIdFn>(async () => {
    try {
      const cart = await extensionShopifyClient.cartGet();
      if (cart.token) {
        return `gid://shopify/Cart/${cart.token}`;
      }
    } catch (error) {
      console.error(error);
    }

    return undefined;
  }, [extensionShopifyClient]);

  return (
    <GetActiveCartIdContext.Provider value={getActiveCartId}>
      {children}
    </GetActiveCartIdContext.Provider>
  );
});
